import { render, staticRenderFns } from "./EdmCampaignSummary.vue?vue&type=template&id=fa49e2d0&scoped=true&"
import script from "./EdmCampaignSummary.vue?vue&type=script&lang=js&"
export * from "./EdmCampaignSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa49e2d0",
  null
  
)

export default component.exports